// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.root[data-v-73e4f9dd]\n{\n\tfont-size: 16px;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\twidth: 100%;\n\theight: 100%;\n}\n.head[data-v-73e4f9dd]\n{\n\twidth: 100%;\n}\n.body[data-v-73e4f9dd]\n{\n\twidth: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
